var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 23",
    style: {
      enableBackground: "new 0 0 23 23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2064B0;}\r\n\t.st1{fill:#2064B0;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,12.7c0,1.1-1.7,2-3.8,2c-2.1,0-3.7-0.9-3.8-2c-3.2,0.3-5.6,2.9-5.6,6.2c0,3.4,2.8,3.4,6.2,3.4h2.7 c0.1-0.1,5.1,0.1,5.1,0c0.4-0.4,1.6-0.3,1.8-0.5c-0.6-0.7-1.3,0-0.1-1.5c0.6-0.7-0.8-0.7-0.1-0.7c0.9,0-1.9-2-1.5-1.6 c0,0,0.1,0.1,0.1,0.1c0.9,0.9,0.7,2.5-0.2,4.2c2.7-0.1,4.8-0.5,4.8-3.4C19.6,15.7,17.1,13,14,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.7,9.8c-0.4-0.4-0.8-0.9-1.4-0.9c-0.4,0-0.8,0.3-1.3,0.8c-1.1,1.4-0.7,2,0,2.6l0.1,0.1 c0.1,0.1,0,0.3-0.2,0.7c-0.2,0.4-0.6,0.8-1.2,1.4c-1.3,1.3-1.8,1.4-1.9,1.4c-0.1,0-0.1,0-0.1,0l-0.1-0.1c-0.3-0.3-0.7-0.7-1.2-0.7 c-0.4,0-0.9,0.2-1.4,0.7c-0.5,0.4-0.8,0.8-0.8,1.2c0,0.6,0.5,1.1,0.8,1.4c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.6,0.3,1,0.3 c1.1,0,3.1-0.7,5.1-2.8c2.5-2.5,3.4-5.3,2.5-6.2C21.8,9.9,21.8,9.9,21.7,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,5.6c-0.2-1.5-1-2.9-2.4-3.6v1.1c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0-1.3,0-1.4 c-0.1-0.5-0.6-1-1.2-1S9.1,1.1,9,1.7C9,1.8,9,3,9,3.1c0,0.5-0.8,0.5-0.8,0v-1C6.9,2.7,6,4.1,5.8,5.6C5.4,5.8,5,6.2,5,6.7 c0,0.7,0.6,1.2,1.2,1.2h7.9C15.5,7.9,15.8,6.1,14.6,5.6z M8.2,13c2.7,1.5,5.9-0.4,6.2-3.5l0.1-0.8c-0.3,0.1-8.3,0.1-8.6,0L6,9.5 C6.2,11,6.9,12.3,8.2,13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnCallIcon);
export default __webpack_public_path__ + "static/media/on-call-icon.c4a49b80d42d106cc478628713275d57.svg";
export { ForwardRef as ReactComponent };